<div class="dentist-avatar mb-2 xs:mb-1" [style.background-image]="'url('+photoUrl+')'"></div>
<div>
  <p class="ft-medium fw-700">{{ fullName }}</p>
  <p class="grey-label ft-small fw-700">{{ specialty }}</p>
</div>
